exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-loading[data-v-4dbb0a03]{color:var(--color-sixth,#663);font-weight:700}.dotIcon[data-v-4dbb0a03]{margin-top:.8rem}main[data-v-4dbb0a03]{width:100%;min-height:70vh}main>section[data-v-4dbb0a03]{width:350px;height:250px;margin:0 auto;background:var(--color-first-0-8);border-radius:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dbb0a03","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Spinner.vue
// module id = 355
// module chunks = 10